import { GUID_VIDE } from '@/configuration/general';

export default function intToGuid(int) {
  let guid = GUID_VIDE;
  const intString = int.toString();
  guid = guid.substr(0, guid.length - intString.length);
  guid += intString;
  return guid;
}
